module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOULD LIKE")]), _vm._v(" to acknowledge the kind help I received in writing this book: from my colleagues, especially Joseph Jaworski, Otto Scharmer, Susan Taylor, and the late Bill O’Brien; from my readers and editors, especially Valerie Andrews, Janet Coleman, Elena Diez Pinto, Kees van der Heijden, Betty Sue Flowers, David Kahane, Art Kleiner, Steve Piersanti, Bettye Pruitt, and Peter Senge; and from my family, especially Dorothy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 81
// module chunks = 0